<template>
  <div class="main-layout">
    <!-- 头部组件 -->
    <AppHeader :navArr="navArr" :index="currentIndex" />
    
    <!-- 主内容区域 -->
    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/Header.vue'

export default {
  name: "MainLayout",
  components: {
    AppHeader,
  },
  data() {
    return {
      navArr: [],
      currentIndex: 0
    };
  },
  methods: {
    handleMainMenuChange(menuItem) {
      console.log('主菜单切换:', menuItem);
      // 处理主菜单切换逻辑
    },
    
    handleSubMenuChange(subMenuItem) {
      console.log('子菜单切换:', subMenuItem);
      // 处理子菜单切换逻辑
    }
  }
};
</script>

<style lang="scss" scoped>
.main-layout {
  min-height: 100vh;
  // background: #F5F5F5;
  background: linear-gradient(45deg, #5A6171 -0.09%, #716A5A 99.91%);
  
}

.main-content {
  padding-left: 160px;
  padding-right: 10px;
}

// 响应式设计
@media (max-width: 768px) {
  .main-content {
    margin-left: 140px;
    padding: 15px;
  }
}
</style>
